export default __webpack_public_path__ + "static/media/shoes2.93881218.jpg";